export default {"src":"/_next/static/media/googlePlay.2d057d37.svg","height":40,"width":123,"blurWidth":0,"blurHeight":0};